module.exports = __webpack_public_path__ + "img/eu.eu227190d.svg";